angular.module('pb.file', ['pb.core', 'ngFileUpload']);
